import { setContext } from "@apollo/client/link/context";

import { authorizationHeaders } from "../../utils/graphqlHelper";

export const authLink = (accessToken: string | null) =>
  setContext((_, { headers }) => {
    // add the authorization to the headers
    return {
      headers: {
        ...headers,
        ...authorizationHeaders(accessToken),
      },
    };
  });
